(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('rmsListFilterToolbar', rmsListFilterToolbar);

    function rmsListFilterToolbar($timeout) {
        return {
            restrict: 'E',
            controller: rmsListFilterToolbarCtrl,
            controllerAs: 'vm',
            bindToController: true,
            templateUrl: 'common/app/components/list-filter/toolbar',
            scope: {},
            link: function(scope) {
                var vm = scope.vm;
                $timeout(function() {
                    if (vm.refreshFilter && typeof vm.refreshFilter() === typeof function() {}) {
                        vm.refreshFilter();
                    }
                });
            }
        };
    }

    function rmsListFilterToolbarCtrl($element, $scope, $filter, lodash) {
        var vm = this;
        this.$onInit = function() {
            $scope.listFilterService = $scope.$parent.listFilterService;
            vm.pageData = {};
            vm.selected_count = 0;
            vm.refreshGrid = $scope.listFilterService.refreshGrid;
            vm.showSelectedActions = showSelectedActions;

            init();

            vm.selectCondition = function(condition) {
                vm.togglePopover();
                if (vm.selected_condition.value !== condition.value) {
                    vm.selected_condition = condition;
                    lodash.set(vm.pageData, 'toolbar.searchData.condition', condition.value);
                    vm.selectedConditionHtml = vm.selected_condition.label + ' <i class="fa fa-caret-down"></i>';
                    if (vm.pageData.toolbar.searchData.items && lodash.size(vm.pageData.toolbar.searchData.items) > 1) {
                        vm.refreshGrid(true);
                    }
                }
            };

            vm.onSelectizeChange = function() {
                vm.refreshGrid(true);
                vm.pageData.grid.resize();
            }
        }

        function init() {
            $scope.listFilterService.sync(vm);
            $scope.$watch(watchSelectAllFlag, selectAllFlagChanged);
            vm.filterBarService = $scope.listFilterService.getFilterService();
            initSelectizeConditions();
        }

        function watchSelectAllFlag() {
            return vm.pageData.toolbar.selection.selected.length;
        }

        function selectAllFlagChanged() {
            vm.selected_count = $filter('stringFormat')(vm.pageData.toolbar.selection.label.selected_count, [vm.pageData.toolbar.selection.selected.length]);
            if (vm.pageData.toolbar.selection.selected.length == 0) {
                hideSelectedActions();
            } else {
                showSelectedActions();
            }
        }

        function showSelectedActions() {
            $element.find('.selected-actions').css('display','inline-block');
            // $element.find('.search-text').addClass('position-left');
        }

        function hideSelectedActions() {
            $element.find('.selected-actions').css('display','');
            // $element.find('.search-text').removeClass('position-left');
        }

        function initSelectizeConditions() {
            if (lodash.get(vm.pageData, 'toolbar.searchBarConfig.simple', true) !== true) {
                vm.selected_condition = lodash.find(vm.pageData.toolbar.searchBarConfig.conditions, { value: vm.pageData.toolbar.searchBarConfig.condition_default });
                lodash.set(vm.pageData, 'toolbar.searchData.condition', vm.selected_condition.value);
                vm.selectedConditionHtml =  vm.selected_condition.label + ' <i class="fa fa-caret-down"></i>';

                angular.merge(vm.pageData.toolbar.searchBarConfig, {
                    create: function(input) {
                        return {
                            value: input,
                            text: input
                        }
                    },
                    onInitialize: function(selectize) {
                        vm.pageData.toolbar.searchBarInstance = selectize;
                    }

                });

                $scope.$watch(function() { return lodash.get(vm.pageData, 'toolbar.searchDataTemp.items.length', 0); }, function() {
                    //console.log('searchDataTemp items changed', vm.pageData.toolbar.searchDataTemp.items);
                    //console.log('searchData items changed', vm.pageData.toolbar.searchData.items);
                });
                $scope.$watch(function() { return vm.pageData.toolbar.searchData.condition; }, function() {
                    //console.log('searchData condition changed', vm.pageData.toolbar.searchData.condition);
                    vm.selected_condition = lodash.find(vm.pageData.toolbar.searchBarConfig.conditions, { value: vm.pageData.toolbar.searchData.condition });
                    vm.selectedConditionHtml =  vm.selected_condition.label + ' <i class="fa fa-caret-down"></i>';
                });

            }
        }
    }
})();
